import React from 'react';
import styled from '@emotion/styled';
import css from '@styled-system/css';
import shouldForwardProp from '@styled-system/should-forward-prop';
import PropTypes from 'prop-types';
import { variant } from 'styled-system';

import { Box } from '../../layouts';

const StyledCircledNumber = styled(Box, {
  shouldForwardProp,
})(
  css({
    borderRadius: 5,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    fontFamily: 'body',
  }),
  variant({
    prop: 'size',
    variants: {
      small: {
        fontSize: 'body.0',
        width: '16px',
        height: '16px',
      },
      medium: {
        fontSize: 'body.1',
        width: '24px',
        height: '24px',
      },
    },
  }),
  ({ color, backgroundColor }) => css({ color, backgroundColor })
);

const CircledNumber = React.forwardRef(
  (
    {
      size = 'small',
      color = 'white',
      backgroundColor = 'informative.default',
      ...rest
    },
    ref
  ) => (
    <StyledCircledNumber
      ref={ref}
      size={size}
      color={color}
      backgroundColor={backgroundColor}
      {...rest}
    />
  )
);

CircledNumber.propTypes = {
  size: PropTypes.oneOf(['small', 'medium']),
  /** any theme color */
  color: PropTypes.string,
  /** any theme color */
  backgroundColor: PropTypes.string,
};
export default CircledNumber;
